import { useSelectActiveInput } from 'portfolio/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { useServices } from 'app/hooks';

export function useActiveInputSupportsFilter() {
    const input = useSelectActiveInput();
    return (
        input.activeInputType === 'Widget' &&
        input.activeInputWidget!.type === WidgetType.BLOTTER
    );
}

export function useUpdateActiveFilter(fieldName: string) {
    const { portfolioService } = useServices();
    return (exclude: boolean, values: string[]) => {
        portfolioService.updateActiveFilter(fieldName, values, exclude);
    };
}
